import { render } from "./MainRanking.vue?vue&type=template&id=3ae792a3&scoped=true"
import script from "./MainRanking.vue?vue&type=script&lang=js"
export * from "./MainRanking.vue?vue&type=script&lang=js"

import "./MainRanking.vue?vue&type=style&index=0&id=3ae792a3&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae792a3"]])

export default __exports__